import axios from "axios";
import initialConfig from "@configs/initialConfig";
import MySwalBlockUi from "@pageUtils/block-ui";
// ** GET Products
export const getCourses = (params) => {
  return (dispatch) => {
    return axios
      .post(initialConfig.ipServer.concat("/api/course/get/course"), { params })
      .then((res) => {
        if (res.data.statusDesc === "ไม่สามารถเข้าถึงข้อมูลได้") {
          window.location.href = "/course";
          return;
        }
        dispatch({ type: "GET_COURSE_IN_HOUSE_COURSES", data: res.data, params });
      });
  };
};

export const getCourseDetail = (params) => {
  return (dispatch) => {
    return axios
      .post(initialConfig.ipServer.concat("/api/course/get/course"), { params })
      .then((res) => {
        if (res.data.statusDesc === "ไม่สามารถเข้าถึงข้อมูลได้") {
          window.location.href = "/course";
          return;
        }
        dispatch({
          type: "GET_COURSE_IN_HOUSE_COURSE_DETAIL",
          data: res.data,
          params,
        });
      });
  };
};

export const saveCourseRegistration = (params) => {
  const mySwal = MySwalBlockUi();
  const { courseId, transactionCourseUserStatus, callBackFunction } = params;
  axios
    .post(
      initialConfig.ipServer.concat("/api/course/save/course/registration"),
      {
        courseId: courseId,
        transactionCourseUserStatus: transactionCourseUserStatus,
      }
    )
    .then((res) => {
      mySwal.close();
      callBackFunction({
        type: "SAVE_COURSE_IN_HOUSE_COURSE_REGISTRATION",
        data: res.data,
      });
    });
};

export const getCourseInitial = () => {
  return (dispatch) => {
    const mySwal = MySwalBlockUi();
    return axios
      .get(initialConfig.ipServer.concat("/api/course/get/data/initial"))
      .then((res) => {
        mySwal.close();
        dispatch({ type: "GET_COURSE_IN_HOUSE_COURSE_INITIAL", data: res.data });
      });
  };
};
